import { render, staticRenderFns } from "./AccountantsTotals.vue?vue&type=template&id=c8dc7d50"
import script from "./AccountantsTotals.vue?vue&type=script&lang=js"
export * from "./AccountantsTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports